"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

// Step 10.5 commit 8 / BUG 1: EN/ES toggle on /sign-in.
// Marketing nav is suppressed on /sign-in by the split-screen layout
// (the brand panel owns the chrome), so the locale switch lives in
// the top-right corner of the form panel. Sets the same mag-locale
// cookie used everywhere else, then router.refresh() so the server-
// rendered strings re-render in the new locale. Step 11 bulk welcome
// emails will land Spanish-speaking clients on /sign-in, and they
// need to see the toggle BEFORE signing in.

type Lang = "EN" | "ES";

export function SignInLangToggle({
  initialLocale,
}: {
  initialLocale: "en" | "es";
}) {
  const router = useRouter();
  const [lang, setLang] = useState<Lang>(initialLocale === "es" ? "ES" : "EN");

  function handleChange(next: Lang) {
    setLang(next);
    const cookieValue = next === "ES" ? "es" : "en";
    // eslint-disable-next-line react-hooks/immutability -- MKT-#82(e): document.cookie write inside an event handler is a standard DOM side effect, not a render-time mutation; false positive.
    document.cookie = `mag-locale=${cookieValue}; path=/; max-age=31536000; samesite=lax`;
    router.refresh();
  }

  return (
    <div
      role="group"
      aria-label="Language"
      data-testid="sign-in-lang-toggle"
      className="absolute right-6 top-6 inline-flex items-center rounded-full border border-brand-border bg-white p-0.5 text-xs font-semibold shadow-sm md:right-10 md:top-10"
    >
      {(["EN", "ES"] as const).map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => handleChange(code)}
            aria-pressed={active}
            className={
              active
                ? "rounded-full bg-brand-teal px-3 py-1 text-white"
                : "rounded-full px-3 py-1 text-brand-text-muted transition-colors hover:text-brand-text"
            }
          >
            {code}
          </button>
        );
      })}
    </div>
  );
}
